import { render, staticRenderFns } from "./waterBillTable.vue?vue&type=template&id=f35d2120&scoped=true"
import script from "./waterBillTable.vue?vue&type=script&lang=js"
export * from "./waterBillTable.vue?vue&type=script&lang=js"
import style0 from "./waterBillTable.vue?vue&type=style&index=0&id=f35d2120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35d2120",
  null
  
)

export default component.exports